import { useSharedPdfViewerGate } from '@liscio/common';

import PspdfkitDocumentPDFViewer, {
  type PspdfkitDocumentPDFViewerProps,
} from './PspdfkitDocumentPDFViewer';
import SharedDocumentPDFViewer from './SharedDocumentPDFViewer';

type DocumentPDFViewerProps = PspdfkitDocumentPDFViewerProps & {
  /** Current display name for the shared viewer, which reads it live. PSPDFKit
   * keeps `fileName` and receives renames through its instance. */
  title: string;
};

/**
 * Thin switch between the legacy Files viewers. The gate is held for this mount,
 * so a flag change can't swap the viewer and lose a note draft.
 */
export default function DocumentPDFViewer({
  title,
  ...props
}: DocumentPDFViewerProps) {
  const sharedViewer = useSharedPdfViewerGate();
  return sharedViewer ? (
    <SharedDocumentPDFViewer {...props} fileName={title} />
  ) : (
    <PspdfkitDocumentPDFViewer {...props} />
  );
}
